export default "__VITE_ASSET__CzZno$n1__"